import AddEditModalDX from "../../business/addeditmodaldx";
import { t } from "i18next";
import TextFieldDX from "../../controls/textfielddx";
import GridDX from "../../layout/griddx";
import TypographyDX from "../../layout/typographydx";
import UnitsDatePicker from "../../units_controls/units_datepicker";
import moment from "moment";
import { useNotificationContext } from "../../../context/notificationcontext";

const ItemQCForm = (props: any) => {
  const { data, onChange, onDateChange, handleClose } = props;
  const { setError } = useNotificationContext();

  const onSave = () => {
    if (
      parseInt(data.usableUnits ?? 0) +
        parseInt(data.unusableUnits ?? 0) +
        parseInt(data.quarantineUnits ?? 0) >
      data.quantityReceived
    )
      setError(t("Quantity entered is greater than total received"));
    else if (!data.usableUnits) setError(t("Enter the quantity usable"));
    else handleClose(true);
  };

  return (
    <AddEditModalDX
      open={true}
      title={t("Check Item")}
      handleClose={handleClose}
      maxWidth="sm"
      onSaveClick={onSave}
      onYesClick={handleClose}
    >
      <GridDX container rowSpacing={2} columnSpacing={1}>
        <GridDX item xs={12}>
          <TypographyDX fontWeight={"bold"}>
            {`${t("Selected SKU")}: `}
          </TypographyDX>
          <TypographyDX mx={1}>{data.skuName}</TypographyDX>
        </GridDX>
        <GridDX item xs={12} mb={1}>
          <TypographyDX fontWeight={"bold"}>{`${t("Code")}: `}</TypographyDX>
          <TypographyDX mx={1}>{data.skuCode}</TypographyDX>
        </GridDX>
        <GridDX item xs={12} mb={1}>
          <TypographyDX fontWeight={"bold"}>
            {t("Recieved Units: ")}
          </TypographyDX>
          <TypographyDX mx={1}>
            {`${data.quantityReceived}/${data.quantity}`}
          </TypographyDX>
        </GridDX>
        <GridDX item xs={12} md={4}>
          <TextFieldDX
            label={t("Usable Units")}
            name="usableUnits"
            value={data.usableUnits}
            onChange={onChange}
            type="number"
            // Disable spin buttons for number input
            className="noSpinButtons"
          />
        </GridDX>
        <GridDX item xs={12} md={4}>
          <TextFieldDX
            label={t("Unusable Units")}
            name="unusableUnits"
            value={data.unusableUnits}
            onChange={onChange}
            type="number"
            // Disable spin buttons for number input
            className="noSpinButtons"
          />
        </GridDX>
        <GridDX item xs={12} md={4}>
          <TextFieldDX
            label={t("Quarantine Units")}
            name="quarantineUnits"
            value={data.quarantineUnits}
            onChange={onChange}
            type="number"
            // Disable spin buttons for number input
            className="noSpinButtons"
          />
        </GridDX>
        <GridDX item xs={12} md={6}>
          <TextFieldDX
            label={t("Batch Number")}
            name="batchNumber"
            value={data.batchNumber}
            onChange={onChange}
          />
        </GridDX>
        <GridDX item xs={12} md={6}>
          <UnitsDatePicker
            label={t("Expiry Date")}
            name="expiryDate"
            value={moment(data.expiryDate)}
            onChange={(value: any) => onDateChange(value, "expiryDate")}
          />
        </GridDX>
      </GridDX>
    </AddEditModalDX>
  );
};

export default ItemQCForm;
